export default __webpack_public_path__ + "static/media/City-Centre.44727171.jpg";